export class Bank {
    constructor(public data: {
        Id?: Number,
        Code: String,
        Name: String,
        SwiftCode: String,
        Platimatik: Boolean
    }) { }
}